interface PreviewWatermarkProps {
  children: React.ReactNode;
}

export default function PreviewWatermark({ children }: PreviewWatermarkProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl">
      {/* Watermark overlay - contained within parent */}
      <div
        className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center overflow-hidden"
        aria-hidden="true"
      >
        <div
          className="text-[80px] sm:text-[100px] font-bold text-gray-400/15 select-none whitespace-nowrap -rotate-[30deg]"
        >
          PREVIEW
        </div>
      </div>
      {/* Actual content */}
      <div className="relative z-0">{children}</div>
    </div>
  );
}
